import {
  paidMediaDigits,
  paidMediaFixedDigits,
  paidMediaNumericToken,
} from "./paidMediaNumberFormat";

const EM_DASH = "—";

const isRenderableNumber = (value: number | null | undefined): value is number =>
  value !== null && value !== undefined && Number.isFinite(value);

export const formatOverviewCurrency = (
  value: number | null | undefined,
  currency: string | null | undefined,
  options?: { compact?: boolean }
): string => {
  if (!isRenderableNumber(value)) {
    return EM_DASH;
  }

  const prefix = currency?.trim() ? `${currency.trim()} ` : "";
  const compact = options?.compact ?? true;

  if (!compact) {
    return paidMediaNumericToken(`${prefix}${paidMediaDigits(Math.round(value))}`);
  }

  const abs = Math.abs(value);
  if (abs >= 1_000_000) {
    return paidMediaNumericToken(
      `${prefix}${paidMediaFixedDigits(value / 1_000_000, abs >= 10_000_000 ? 1 : 2)}M`
    );
  }
  if (abs >= 1_000) {
    return paidMediaNumericToken(`${prefix}${paidMediaDigits(Math.round(value / 1_000))}K`);
  }
  return paidMediaNumericToken(`${prefix}${paidMediaDigits(Math.round(value))}`);
};

export const formatOverviewMultiplier = (
  value: number | null | undefined,
  fractionDigits = 2
): string =>
  isRenderableNumber(value)
    ? paidMediaNumericToken(`${paidMediaFixedDigits(value, fractionDigits)}x`)
    : EM_DASH;

/** Unisolated so Arabic renders the `%` on the left of the digits — see `formatPaidMediaPercent`. */
export const formatOverviewPct = (
  value: number | null | undefined,
  fractionDigits = 1
): string =>
  isRenderableNumber(value) ? `${paidMediaFixedDigits(value, fractionDigits)}%` : EM_DASH;

export const formatOverviewNumber = (value: number | null | undefined): string =>
  isRenderableNumber(value)
    ? paidMediaNumericToken(paidMediaDigits(Math.round(value)))
    : EM_DASH;

export const formatOverviewIndex = (
  value: number | null | undefined,
  fractionDigits = 2
): string =>
  isRenderableNumber(value)
    ? paidMediaNumericToken(paidMediaFixedDigits(value, fractionDigits))
    : EM_DASH;

export const formatOverviewText = (value: string | null | undefined): string =>
  value?.trim() ? value : EM_DASH;

export { EM_DASH as OVERVIEW_EMPTY_VALUE };
